<template>
  <div class="table">
    <RowItem
      v-if="data.folder"
      :data="data.folder"
      :count="count"
      :padding-left="paddingLeft"
      :is-folder="true"
      :parent-folder="parentFolder"
      :is-open="isOpen"
      @click="toggleClick"
    ></RowItem>
    <transition duration="200" name="fade">
      <div v-if="isOpen" class="table__next">
        <template v-if="data.childrenFolders && data.childrenFolders.length">
          <TableRow
            v-for="folder in data.childrenFolders"
            :key="folder.id"
            :data="folder"
            :padding-left="padding"
            :parent-folder="data.folder"
          ></TableRow>
        </template>
        <template v-if="data.groupArray && data.groupArray.length">
          <RowItem
            v-for="(group, idx) in data.groupArray"
            :key="'group' + idx"
            :padding-left="padding"
            :data="group"
            :parent-folder="parentFolder"
            :folder="data.folder"
          ></RowItem>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import RowItem from './RowItem';

export default {
  name: 'TableRow',
  components: {
    RowItem
  },
  props: ['data', 'paddingLeft', 'parentFolder'],
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    count() {
      let folderLvlOne =
        this.data.groupArray
          ?.map(el => el.count)
          .reduce((prev, next) => parseInt(prev) + parseInt(next), 0) ?? 0;

      if (this.data.childrenFolders && this.data.childrenFolders.length) {
        for (let i = 0; i < this.data.childrenFolders.length; i++) {
          folderLvlOne += this.counter(this.data.childrenFolders[i]);
        }
      }
      return folderLvlOne;
    },
    padding() {
      return +this.paddingLeft + 20;
    }
  },
  methods: {
    counter(data) {
      let str =
        data.groupArray
          ?.map(el => el.count)
          .reduce((prev, next) => parseInt(prev) + parseInt(next), 0) ?? 0;
      if (data.childrenFolders && data.childrenFolders.length) {
        for (let i = 0; i < data.childrenFolders.length; i++) {
          str += this.counter(data.childrenFolders[i]);
        }
      }
      return str;
    },
    toggleClick() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
